var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { appendClassName } from "./view-helpers";
function ErrorBoundary(_a) {
    var { children, className, error } = _a, rest = __rest(_a, ["children", "className", "error"]);
    if (error) {
        return (React.createElement("div", Object.assign({ className: appendClassName("sui-search-error", className) }, rest), error));
    }
    return children;
}
export default ErrorBoundary;
